import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Modal, Input } from "antd";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Container } from "react-bootstrap";
import { ArrowRightOutlined } from "@ant-design/icons";
import AppliedCoupon from "./appliedCoupon";
import CouponTitle from "./couponTitle";
import iconPercentage from "../../../assets/images/icon_percentage.png";
import { Radio } from "antd";

const ApplyCoupon = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  return (
    <section className="apply-coupon">
      <div className="apply-coupon-wrap">
        <Link to="" onClick={showModal} className="apply-coupen ">
          <img src={iconPercentage} className="fare-percentage-icon" />
          apply coupon
        </Link>

        <Modal
          visible={isModalVisible}
          onOk={handleOk}
          onCancel={handleCancel}
          centered=" true"
          title={null}
          header={null}
          footer={null}
        >
          <Container>
            <Row>
              <Col>
                <CouponTitle title="Have a Coupon Code" />
              </Col>
            </Row>

            <div className="enter-promo-wrap">
              <Row>
                <Col md={9}>
                  <img src={iconPercentage} className="percentage-icon" />
                  <Input placeholder="Enter Promo Code" />
                </Col>
                <Col md={3}>
                  <AppliedCoupon />
                </Col>
                <p className="pt-3 choose-offer">
                  Or choose an offer from below.
                </p>
              </Row>
            </div>

            <Row>
              <Col>
                <div className="radio-input">
                <Radio className="radio-value" value={1}>mansoon</Radio>
                </div>

                <div className="vouchers-wrap">
                  <p>
                    Get exciting vouchers from our partners - AJIO, Myntra,
                    Medibuddy, CoinDCX, Cleartax, and EduBridge.
                  </p>
                  <div className="apply">
                    <span>Valid till 30th Sep 2022</span>
                    <div className="apply-btn">
                      T&C apply <ArrowRightOutlined />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </Modal>
      </div>
    </section>
  );
};

export default ApplyCoupon;
